import React from 'react';
import {useIntl} from 'react-intl';

export default function HashValidatingView() {
    const intl = useIntl();
    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <h1>{intl.formatMessage({id: 'hashValidatingTitle'})}</h1>
        </div>
    );
}
